// extracted by mini-css-extract-plugin
var _1 = "hasNoMargin-zbT6";
var _2 = "loader-pxQQ";
var _3 = "loaderContainer-J4bv";
var _4 = "medium-UL4e";
var _5 = "small-gB_l";
var _6 = "spin-HjrE";
var _7 = "tiny-pJhe";
export { _1 as "hasNoMargin", _2 as "loader", _3 as "loaderContainer", _4 as "medium", _5 as "small", _6 as "spin", _7 as "tiny" }
